import { render, staticRenderFns } from "./ChatNoteModal.vue?vue&type=template&id=6c7cbdb5&"
import script from "./ChatNoteModal.vue?vue&type=script&lang=js&"
export * from "./ChatNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports